<template>
  <el-dialog
    title="任务详情"
    :visible.sync="showDetailDialog"
    width="800px"
    center
    @close="closeDetailDialog"
  >
    <div class="details-container">
      <table class="details-table">
        <tbody>
          <tr>
            <td class="label">任务类型:</td>
            <td class="content">{{ taskDetail.task_type_text || '暂无' }}</td>
          </tr>
          <tr>
            <td class="label">任务名称:</td>
            <td class="content">{{ taskDetail.name || '暂无' }}</td>
          </tr>
          <tr>
            <td class="label">bid:</td>
            <td class="content">{{ taskDetail.bid || '暂无' }}</td>
          </tr>
          <tr>
            <td class="label">自定义标签:</td>
            <td class="content">{{ taskDetail.tags || '暂无' }}</td>
          </tr>
          <tr>
            <td class="label">精准搜索名称:</td>
            <td class="content">{{ taskDetail.keyword || '暂无' }}</td>
          </tr>
          <tr>
            <td class="label">媒体:</td>
            <td class="content">{{ taskDetail.media_ids_text || '暂无' }}</td>
          </tr>
          <tr>
            <td class="label">设备:</td>
            <td class="content">{{ taskDetail.mobile_type || '暂无' }}</td>
          </tr>
          <tr>
            <td class="label">广告形式:</td>
            <td class="content">{{ taskDetail.ad_form_text || '暂无' }}</td>
          </tr>
          <tr>
            <td class="label">素材类型:</td>
            <td class="content">
              {{ taskDetail.material_type_text || '暂无' }}
              <span v-if="taskDetail.material_type_text === '图片'">
                （{{ taskDetail.image_type_text || '暂无' }}）
              </span>
            </td>
          </tr>
          <tr>
            <td class="label">产品类型:</td>
            <td class="content">
              {{ taskDetail.product_types_text || '暂无' }}
            </td>
          </tr>
          <tr>
            <td class="label">布局:</td>
            <td class="content">{{ taskDetail.layout_text || '暂无' }}</td>
          </tr>
          <tr>
            <td class="label">清晰度:</td>
            <td class="content">
              {{ taskDetail.definition_type_text || '暂无' }}
            </td>
          </tr>
          <tr>
            <td class="label">视频时长:</td>
            <td class="content">{{ taskDetail.duration_param || '暂无' }}</td>
          </tr>
          <tr>
            <td class="label">排序方式:</td>
            <td class="content">{{ taskDetail.sort_by || '暂无' }}</td>
          </tr>
          <tr>
            <td class="label">日期范围:</td>
            <td class="content">
              {{ taskDetail.start_date || '暂无' }} 至
              {{ taskDetail.end_date || '暂无' }}
            </td>
          </tr>
          <tr>
            <td class="label">爬取页数:</td>
            <td class="content">{{ taskDetail.page || '暂无' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <template #footer>
      <el-button type="primary" @click="closeDetailDialog">关闭</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { taskDetail } from '@/api/miniAd'

export default {
  name: 'TaskDetailDialog',
  computed: {
    ...mapGetters('dialog', ['showTaskDetailDialog', 'currentTaskId']),
    showDetailDialog: {
      get() {
        return this.showTaskDetailDialog
      },
      set(value) {
        if (!value) {
          this.closeDetailDialog()
        }
      }
    }
  },
  data() {
    return {
      taskDetail: {}
    }
  },
  watch: {
    currentTaskId(newId) {
      if (newId !== null) {
        this.fetchTaskDetail()
      } else {
        this.taskDetail = {}
      }
    }
  },
  methods: {
    ...mapActions('dialog', ['closeTaskDetailDialog']),
    async fetchTaskDetail() {
      if (!this.currentTaskId) return
      try {
        const response = await taskDetail({ id: this.currentTaskId })
        this.taskDetail = response.data || {}
      } catch (error) {
        console.error('获取任务详情失败:', error)
        this.$message.error('获取任务详情失败，请稍后重试！')
      }
    },
    closeDetailDialog() {
      this.closeTaskDetailDialog()
      this.taskDetail = {}
    }
  }
}
</script>

<style scoped>
.details-container {
  margin: 20px 0;
}

.details-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.details-table td {
  padding: 10px;
  border: 1px solid #ebeef5;
}

.details-table .label {
  width: 30%;
  background-color: #f9f9f9;
  font-weight: bold;
  color: #606266;
}

.details-table .content {
  width: 70%;
  color: #333;
}
</style>
